export enum AppRoutes {
    home = "/",
    day = "/day",
    month = "/month",
    attentiondays = "/attentiondays",
    employeegroups = "/employeegroups",
    bhvDay = "/bhv/day",
}
